<template>
  <div>
    <ExtEnvComponent></ExtEnvComponent>
    <CRow>
      <CCol col="12">
        <CCard>
          <CCardBody class="p-2">
            <CForm inline>
              <label
                class="col-form-label ml-2 mr-2"
                style="min-width: 55px; display: block"
                >검색조건</label
              >
              <CSelect
                :value.sync="inFacilityId"
                :options="inFacilityList"
                style="margin-bottom: 0; width: 97%"
                class="ml-2 ml-sm-0 w-auto-sm"
              >
              </CSelect>

              <div
                role="group"
                class="form-group form-row ml-2 mt-2 mt-sm-0 w-100 w-auto-sm"
              >
                <v-date-picker
                  v-model="searchAtRange"
                  is-range
                  :max-date="getMaxDate()"
                  :masks="{ title: 'YYYY년 MMM', L: 'YYYY-MM-DD' }"
                  class="w-100"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <div class="w-100 flex justify-center items-center">
                      <input
                        :value="inputValue.start"
                        v-on="inputEvents.start"
                        class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                        style="height: 35px; width: 47%"
                      />
                      ~
                      <input
                        :value="inputValue.end"
                        v-on="inputEvents.end"
                        class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                        style="height: 35px; width: 47%"
                      />
                    </div>
                  </template>
                </v-date-picker>
              </div>
            </CForm>
            <CForm inline class="mt-2 mb-2 mb-sm-0">
              <label
                class="col-form-label ml-2 mr-2"
                style="min-width: 55px; display: block"
                >센서</label
              >
              <CSelect
                placeholder="센서환경을 선택하세요"
                :value.sync="sensorEnvType.selected"
                :options="sensorEnvType.list"
                style="margin-bottom: 0; width: 97%"
                class="ml-2 ml-sm-0 w-auto-sm"
              >
              </CSelect>

              <CSelect
                placeholder="센서를 선택하세요"
                :value.sync="sensorEnvType.selectedSensorEnv.selected"
                :options="sensorEnvType.selectedSensorEnv.list"
                v-if="sensorEnvType.selectedSensorEnv != null"
                style="margin-bottom: 0; width: 97%"
                class="ml-2 mt-2 mt-sm-0 w-auto-sm"
              >
              </CSelect>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol col="12">
        <CCard>
          <CCardBody class="p-2">
            <CRow>
              <CCol lg="6">
                <div
                  ref="chart"
                  style="width: 100%; height: 400px"
                  :class="
                    chart == null || chart.data.length === 0 ? 'd-none' : ''
                  "
                ></div>
              </CCol>
              <CCol lg="6">
                <div
                  ref="heatmap"
                  style="width: 100%; height: 400px"
                  :class="
                    heatmap == null || heatmap.data.length === 0 ? 'd-none' : ''
                  "
                ></div>
              </CCol>
            </CRow>
            <div
              style="
                width: 100%;
                height: 400px;
                display: flex;
                justify-content: center;
                flex-direction: column;
                text-align: center;
                font-weight: bold;
                font-size: 150%;
                color: #ff0d0d;
              "
              v-if="(chart == null || chart.data.length === 0) && (heatmap == null || heatmap.data.length === 0)"
            >
              <div>
                <i class="fa fa-times-circle" aria-hidden="true"></i>
                데이터 없음
              </div>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import core from "@/core";
import SensorService from "@/services/sensor/sensor.service";
import store from "@/store";
import ExtEnvComponent from "@/components/monitoring/ExtEnvComponent";
import MixinsInFacility from "@/mixins/in-facility";

export default {
  name: "Sensor",
  components: { ExtEnvComponent },
  mixins: [MixinsInFacility()],
  data() {
    return {
      // 센서 환경 정보
      sensorEnvType: {
        selected: null,
        list: [
          { label: "실내부", value: "inEnv" },
          { label: "근권부", value: "rootEnv" },
          { label: "양액부", value: "nutrientSolution" },
        ],
        selectedSensorEnv: null,
        types: {
          inEnv: {
            selected: null,
            defaultValue: "temp",
            list: [
              {
                label: "온도",
                value: "temp",
                unit: "℃",
                range: { min: -50, max: 50 },
              },
              {
                label: "습도",
                value: "humidity",
                unit: "%",
                range: { min: 0, max: 100 },
              },
              {
                label: "co2",
                value: "co2",
                unit: "ppm",
                range: { min: 0, max: 5000 },
              },
              {
                label: "일사량",
                value: "solarRadiation",
                unit: "",
                range: { min: 0, max: 1000 },
              },
            ],
            getListFunction: SensorService.getInEnvAvgList,
            data: null,
          },
          rootEnv: {
            selected: null,
            defaultValue: "temp",
            list: [
              {
                label: "온도",
                value: "temp",
                unit: "℃",
                range: { min: -50, max: 50 },
              },
              {
                label: "습도",
                value: "humidity",
                unit: "%",
                range: { min: 0, max: 100 },
              },
              {
                label: "배액EC",
                value: "drainageEc",
                unit: "",
                range: { min: 0, max: 100 },
              },
              {
                label: "배액PH",
                value: "drainagePh",
                unit: "",
                range: { min: 0, max: 100 },
              },
            ],
            getListFunction: SensorService.getRootEnvAvgList,
            data: null,
          },
          nutrientSolution: {
            selected: null,
            defaultValue: "ec",
            list: [
              {
                label: "EC",
                value: "ec",
                unit: "",
                range: { min: 0, max: 100 },
              },
              {
                label: "PH",
                value: "ph",
                unit: "",
                range: { min: 0, max: 100 },
              },
              {
                label: "공급유량",
                value: "flowRate",
                unit: "",
                range: { min: 0, max: 100 },
              },
              {
                label: "공급성분농도",
                value: "constConcen",
                unit: "",
                range: { min: 0, max: 100 },
              },
            ],
            getListFunction: SensorService.getNutrientSolutionAvgList,
            data: null,
          },
        },
      },
      chart: null,
      heatmap: null,
      searchAtRange: {
        start: core.date.instance().add(-1, "days").toDate(),
        end: new Date(),
      },
    };
  },
  created() {
    this.sensorEnvType.selected = "inEnv";
  },
  mounted() {},
  watch: {
    searchAtRange() {
      if (this.sensorEnvType.selectedSensorEnv != null) {
        this.getSensorData().then(()=> {
          this.createSensorChart();
        });
      }
    },
    inFacilityId() {
      const inFacilityId = this.inFacilityId;
      if (
        inFacilityId != null &&
        this.sensorEnvType.selectedSensorEnv != null
      ) {
        this.getSensorData().then(()=> {
          this.createSensorChart();
        });
      }
    },
    "sensorEnvType.selected"(val) {
      // 센서 환경 타입 변경
      if (val != null) {
        this.sensorEnvType.selectedSensorEnv = this.sensorEnvType.types[val];
      }
    },
    async "sensorEnvType.selectedSensorEnv"(val, preVal) {
      // 센서 환경 타입 변경
      console.log("---------- changed selected sensorEnv : ", val);

      await this.getSensorData();

      val.selected = val.defaultValue;
      if (preVal != null) {
        preVal.selected = null;
        if (preVal.selected === val.selected) {
          console.log("changed selected sensorEnv.selected : ", val.selected);
          this.createSensorChart();
        }
      }
    },
    "sensorEnvType.selectedSensorEnv.selected"(val) {
      console.log("changed selected sensorEnv.selected : ", val);
      this.createSensorChart();
    },
  },
  methods: {
    getPreWeekAvg(daySize, preWeekList, preWeekStartAt, sensorKeyList) {
      const dayItemMap = new Map();
      // 일주일 평균 데이터 생성
      for (let i = 0; i < daySize; i++) {
        let dayItem = dayItemMap.get(i);
        if (dayItem == null) {
          dayItem = new Map();
          dayItemMap.set(i, dayItem);
        }
        const preWeekStartMoment = core.date
          .instance(preWeekStartAt)
          .add(i, "days");

        preWeekList.forEach((inEnv) => {
          const sensingMoment = core.date.instance(inEnv.sensingAt);
          const days = core.date
            .duration(
              core.date
                .instance(sensingMoment.format("YYYY-MM-DD 00:00:00"))
                .diff(
                  core.date.instance(
                    preWeekStartMoment.format("YYYY-MM-DD 00:00:00"),
                  ),
                ),
            )
            .asDays();
          if (days < 7) {
            const strTime = sensingMoment.format("HH:mm:ss");
            let item = dayItem.get(strTime);
            if (item == null) {
              item = {
                list: [],
                avg: null,
              };
              dayItem.set(strTime, item);
            }
            item.list.push(inEnv);
          }
        });
      }

      // 날짜별 평균값 계산
      dayItemMap.forEach((dayItem, key, map) => {
        dayItem.forEach((timeItem, key) => {
          //console.log("key : ", key);
          if (timeItem.avg == null) {
            timeItem.avg = {};
            sensorKeyList.forEach((sensorKey) => {
              timeItem.avg[sensorKey] = null;
              const upperKey =
                sensorKey.charAt(0).toUpperCase() + sensorKey.slice(1);
              timeItem.avg["min" + upperKey] = null;
              timeItem.avg["max" + upperKey] = null;
            });
          }

          timeItem.list.forEach((sensorItem) => {
            sensorKeyList.forEach((sensorKey) => {
              const upperKey =
                sensorKey.charAt(0).toUpperCase() + sensorKey.slice(1);

              if (timeItem.avg[sensorKey] == null) {
                timeItem.avg[sensorKey] = sensorItem[sensorKey];
                timeItem.avg["count" + upperKey] = 1;
              } else if (sensorItem[sensorKey] != null) {
                timeItem.avg[sensorKey] += sensorItem[sensorKey];
                timeItem.avg["count" + upperKey]++;
              }

              let key = null;

              key = "min" + upperKey;
              if (timeItem.avg[key] == null) {
                timeItem.avg[key] = sensorItem[key];
              } else if (timeItem.avg[key] > sensorItem[key]) {
                timeItem.avg[key] = sensorItem[key];
              }

              key = "max" + upperKey;
              if (timeItem.avg[key] == null) {
                timeItem.avg[key] = sensorItem[key];
              } else if (timeItem.avg[key] < sensorItem[key]) {
                timeItem.avg[key] = sensorItem[key];
              }
            });
          });
          sensorKeyList.forEach((sensorKey) => {
            if (timeItem.avg[sensorKey] != null) {
              const upperKey =
                sensorKey.charAt(0).toUpperCase() + sensorKey.slice(1);
              timeItem.avg[sensorKey] = Number(
                (
                  timeItem.avg[sensorKey] / timeItem.avg["count" + upperKey]
                ).toFixed(2),
              );
            }
          });
        });
      });
      console.log("dayItemMap : ", dayItemMap);
      return dayItemMap;
    },
    async getSensorData() {
      console.log("getSensorData");
      const inFacilityId = this.inFacilityId;
      if (inFacilityId != null) {
        const sensorEnvType = this.sensorEnvType.selected;
        if (sensorEnvType == null) {
          console.log("Unknown sensorEnvType : ", sensorEnvType);
          return;
        }
        core.loader.show();

        const standardMoment = core.date.instance(this.searchAtRange.start);
        const endMoment = core.date
          .instance(this.searchAtRange.end)
          .add(1, "days");

        console.log("standardMoment : ", standardMoment.format("YYYY-MM-DD"));

        // 일주일 전 평균값 조회
        const preWeekStartMoment = core.date
          .instance(standardMoment)
          .add(-7, "days");
        const preWeekEndMoment = core.date.instance(endMoment).add(-1, "days");

        this.sensorEnvType.selectedSensorEnv.data = await this.getChartData(
          standardMoment,
          endMoment,
          preWeekStartMoment,
          preWeekEndMoment,
        );
        console.log("update sensor : ", this.sensorEnvType.selectedSensorEnv);
        core.loader.hide();
      }
    },
    async getChartData(
      standardMoment,
      endMoment,
      preWeekStartMoment,
      preWeekEndMoment,
    ) {
      const inFacilityId = this.inFacilityId;
      if (inFacilityId != null) {
        let sensorEnv = this.sensorEnvType.selectedSensorEnv;
        const getListFunction = sensorEnv.getListFunction;

        let daySize = core.date
          .duration(endMoment.diff(standardMoment))
          .asDays();
        console.log("daySize : ", daySize);

        const preWeekList = await getListFunction({
          inFacilityId: inFacilityId,
          type: "H",
          sensingAtGreaterThanEqual: preWeekStartMoment.format("YYYY-MM-DD"),
          sensingAtLessThan: preWeekEndMoment.format("YYYY-MM-DD"),
        });

        const sensorKeyList = [];
        this.sensorEnvType.selectedSensorEnv.list.forEach((sensor) => {
          sensorKeyList.push(sensor.value);
        });
        const dayItemMap = this.getPreWeekAvg(
          daySize,
          preWeekList,
          preWeekStartMoment.format("YYYY-MM-DD 00:00:00"),
          sensorKeyList,
        );

        const list = await getListFunction({
          inFacilityId: inFacilityId,
          type: "H",
          sensingAtGreaterThanEqual: standardMoment.format("YYYY-MM-DD"),
          sensingAtLessThan: endMoment.add(1, "days").format("YYYY-MM-DD"),
        });

        list.forEach((sensor) => {
          const sensingMoment = core.date.instance(sensor.sensingAt);
          sensor.date = sensingMoment.toDate();

          const days = core.date
            .duration(
              core.date
                .instance(sensingMoment.format("YYYY-MM-DD 00:00:00"))
                .diff(
                  core.date.instance(
                    standardMoment.format("YYYY-MM-DD 00:00:00"),
                  ),
                ),
            )
            .asDays();
          const dayItem = dayItemMap.get(days);
          if (dayItem == null) {
            console.log("not found dayItem! ", days);
          } else {
            const strTime = sensingMoment.format("HH:00:00");
            const timeItem = dayItem.get(strTime);
            if (timeItem == null) {
              console.log("not found timeItem! ", strTime);
            } else {
              sensorKeyList.forEach((sensorKey) => {
                const upperKey =
                  sensorKey.charAt(0).toUpperCase() + sensorKey.slice(1);
                let key = null,
                  preWeekKey = null;
                key = "min" + upperKey;
                preWeekKey =
                  "preWeek" + key.charAt(0).toUpperCase() + key.slice(1);
                sensor[preWeekKey] = timeItem.avg[key];

                key = "max" + upperKey;
                preWeekKey =
                  "preWeek" + key.charAt(0).toUpperCase() + key.slice(1);
                sensor[preWeekKey] = timeItem.avg[key];
              });
              //console.log(sensor);
            }
          }
        });
        return {
          preWeekList: preWeekList,
          list: list,
        };
      }
      return null;
    },
    getMaxDate() {
      return core.date.instance().add(1, "days").toDate();
    },
    createChart(params) {
      const $el = this.$refs.chart;
      const chart = core.amchart.createXYDateChart($el);
      const dateFieldName = "date";
      params.columns.forEach((column) => {
        if (column.openFieldName != null) {
          const series = core.amchart.createRangeLineSeries(
            chart,
            column.openFieldName,
            column.fieldName,
            dateFieldName,
            column.name,
            column.colorHex,
            column.unit,
          );
        } else {
          const series = core.amchart.createLineSeries(
            chart,
            column.fieldName,
            dateFieldName,
            column.name,
            column.colorHex,
            column.unit,
          );
        }
      });
      const scrollbarX = new am4core.Scrollbar();
      // chart.legend = new am4charts.Legend();
      chart.cursor = new am4charts.XYCursor();
      chart.scrollbarX = scrollbarX;

      chart.data = null;
      return chart;
    },
    createHeatmap(params) {
      // params = {
      //   name : "이름",
      //   range: {
      //     min: 0,
      //     max: 0
      //   },
      //   data: [],
      //   valueFieldName: "value"
      // };
      const chart = am4core.create(this.$refs.heatmap, am4charts.XYChart);
      chart.maskBullets = false;

      const xAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      const yAxis = chart.yAxes.push(new am4charts.CategoryAxis());

      xAxis.dataFields.category = "day";
      yAxis.dataFields.category = "hour";

      xAxis.renderer.grid.template.disabled = true;
      xAxis.renderer.minGridDistance = 70;

      yAxis.renderer.grid.template.disabled = true;
      yAxis.renderer.inversed = true;
      yAxis.renderer.minGridDistance = 30;

      const series = chart.series.push(new am4charts.ColumnSeries());
      series.name = params.name;
      series.dataFields.categoryX = "day";
      series.dataFields.categoryY = "hour";
      series.dataFields.value = params.valueFieldName;
      console.log("params.valueFieldName : ", params.valueFieldName);
      series.sequencedInterpolation = true;
      series.defaultState.transitionDuration = 3000;

      const columnTemplate = series.columns.template;
      columnTemplate.fillOpacity = 0.8;
      columnTemplate.propertyFields.fill = "color";

      columnTemplate.strokeWidth = 1;
      columnTemplate.strokeOpacity = 0.2;
      columnTemplate.tooltipText =
        "{name} [bold font-size: 20px] {value} [font-size: 12px]" +
        params.unit;
      columnTemplate.width = am4core.percent(100);
      columnTemplate.height = am4core.percent(100);

      const range = params.range;
      if (params.data != null) {
        params.data.forEach((data) => {
          const moment = core.date.instance(data.sensingAt);
          data.day = moment.format("MM월 DD일");
          data.hour = moment.hour() + "시";
          let value = data[params.valueFieldName];
          //console.log("value : ", value);
          if (value != null) {
            value = (1 - (value - range.min) / (range.max - range.min)) * 240;
            data.color = core.color.hslToHex(value, 1, 0.5);
          }
        });
        chart.data = params.data;
      }
      return chart;
    },
    createSensorChart() {
      console.log("createSensorChart");
      let sensorEnv = this.sensorEnvType.selectedSensorEnv;
      let sensor = null;
      for (let i = 0; i < sensorEnv.list.length; i++) {
        const _sensor = sensorEnv.list[i];
        if (_sensor.value === sensorEnv.selected) {
          sensor = _sensor;
          break;
        }
      }

      if (sensor == null) {
        console.log("not found sensor!!");
        return;
      }

      const sensorKey = sensor.value;
      const upperKey = sensorKey.charAt(0).toUpperCase() + sensorKey.slice(1);
      this.chart = this.createChart({
        columns: [
          {
            openFieldName: "preWeekMin" + upperKey,
            fieldName: "preWeekMax" + upperKey,
            name: sensor.label,
            unit: sensor.unit,
            colorHex: "#ffbe7a",
          },
          {
            fieldName: sensorKey,
            name: sensor.label,
            unit: sensor.unit,
            colorHex: "#FF6600",
          },
        ],
      });
      let title = this.chart.titles.create();
      title.text = sensor.label;
      title.fontSize = 25;

      let heatMapData = [];
      if (sensorEnv.data != null) {
        // line 그래프 데이터 업데이트
        this.chart.data = sensorEnv.data.list;
        //console.log("chart data : ", sensorEnv.data);

        // heatmap 그래프 데이터 업데이트
        heatMapData = core.utils.deepCopy(sensorEnv.data.preWeekList);
        sensorEnv.data.list.forEach((_data) => {
          heatMapData.push(core.utils.deepCopy(_data));
        });
        //console.log("heatmap data : ", heatMapData);
      } else {
        console.log("not found sensorData : ", sensorEnv);
      }

      this.heatmap = this.createHeatmap({
        name: sensor.label,
        data: heatMapData,
        valueFieldName: sensor.value,
        range: sensor.range,
        unit: sensor.unit,
      });
      this.heatmap.range = sensor.range;
    },
  },
};
</script>
